"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShardStatus = void 0;
var ShardStatus;
(function (ShardStatus) {
    ShardStatus[ShardStatus["AVAILABLE"] = 0] = "AVAILABLE";
    ShardStatus[ShardStatus["FULL"] = 1] = "FULL";
})(ShardStatus = exports.ShardStatus || (exports.ShardStatus = {}));
//# sourceMappingURL=quickData.js.map